export const STATUSES = {
  NONE: "none",
  REQUESTED: "requested",
  ACTIVE: "active",
}

export const INTEGRATIONS = {
  GENERIC: "generic",
  PARTNER: "partner",
  ALPHA_THEORY: "alpha theory",
  EZE: "eze",
  OMPNT_AI: "ompnt_ai",
}
